export default "__VITE_ASSET__be1118cf__"